import {Tooltip as MantineTooltip, TooltipProps as MantineTooltipProps} from "@mantine/core";

export type TooltipProps = MantineTooltipProps

export const Tooltip = (props: TooltipProps) => {
    const {...rest} = props;
    return <MantineTooltip {...rest} />;
};
